import React from "react";
import { ToastContentProps } from "react-toastify";
import { getToastTranslation } from "../../app/helpers/translationHelper";

interface IParams {
  type: "generic" | "inProgress";
  toastContentProps: ToastContentProps;
}

const DownloadErrorToast: React.FC<IParams> = ({ type, toastContentProps }) => {
  const getText = () => {
    switch (type) {
      case "generic":
        return getToastTranslation("nativeapp_download_generic_error");
      case "inProgress":
        return getToastTranslation("nativeapp_download_already_error");
      default:
        return getToastTranslation("nativeapp_download_generic_error");
    }
  };

  return (
    <div>
      <i className="fas fa-cloud-download-alt" aria-hidden="true"></i>
      <span> {getText()}</span>
    </div>
  );
};

export default DownloadErrorToast;
